"use strict";
var fieldImageCtrl = function($scope, $attrs, $parse, $http) {
  var initNewEntry = function() {
    $scope.canAttachFile = true;
    $scope.canUploadFile = false;
    $scope.canUseFile = false;
    $scope.dianr = "";
    $scope.newEntry = {"value": ""};
  };
  $scope.reserveDiaNr = function(id) {
    $scope.operations = $scope.operations - 1;
    var entry = {};
    entry.value = id;
    entry.isDisabled = false;
    $scope.entries.push(entry);
    initNewEntry();
  };
  $scope.validateDianummer = function(id) {
    $scope.canUploadFile = false;
    $scope.canUseFile = false;
    $scope.showError = false;
    if (typeof id == 'undefined' || id.length < 1) {
      $scope.showHint = false;
      return false;
    }
    if (!validateValue(id)) {
      $scope.showHint = true;
      return false;
    }
    $scope.showHint = false;
    $http.get('/api/dia/' + id + '.json').then(function(response) {
      if (response.data != true) {
        $scope.canUploadFile = true;
      } else {
        $scope.showError = true;
        $scope.canUseFile = true;
      }
    });
  };
  var validateValue = function(value) {
    if (typeof $scope.schema.validation != 'undefined') {
      if ($scope.schema.validation.minlength != 'undefined') {
        if (value.length < $scope.schema.validation.minlength) {
          return false;
        }
      }
      if ($scope.schema.validation.maxlength != 'undefined') {
        if (value.length > $scope.schema.validation.maxlength) {
          return false;
        }
      }
      if ($scope.schema.validation.regex != 'undefined') {
        var re = new RegExp("^(" + $scope.schema.validation.regex + ")$");
        if (!re.test(value)) {
          return false;
        }
      }
    }
    return true;
  };
  var updateValidations = function() {
    if (typeof $scope.validations == 'undefined') {
      return;
    }
    if ($scope.operations > 0) {
      $scope.validations[$scope.name] = false;
    } else {
      $scope.validations[$scope.name] = true;
    }
  };
  $scope.$watch('operations', function() {
    updateValidations();
  });
  initNewEntry();
};
fieldImageCtrl.$inject = ['$scope', '$attrs', '$parse', '$http'];
module.exports = fieldImageCtrl;
